import React from 'react'
import { IconStatusAwaiting } from '../../../../../assets/svg/status-awaiting'
import * as S from '../../styles'

export const CardProcessingPayment = ({ allowance, key }) => {
  return (
    <>
      <S.Card requested key={key}>
        <S.CardHeader>
          <S.MonthAllowance>Mesada de {allowance.formatDate}</S.MonthAllowance>
          <S.NumberAllowance>
            {allowance.number} de {allowance.amountOfItems}
          </S.NumberAllowance>
        </S.CardHeader>

        <S.WrapperCard>
          <S.WrapperItem>
            <p>Previsão de depósito</p>
            <p>{allowance.scheduledDate}</p>
          </S.WrapperItem>
        </S.WrapperCard>

        <S.WrapperCard>
          <S.WrapperItem>
            <p>Caso a data de pagamento caia no final de semana ou feriado o pagamento será realizado no próximo dia útil.</p>
          </S.WrapperItem>
        </S.WrapperCard>

        <S.FooterCard>
          <S.ButtonFooterCardRequested>
            Processando pagamento <IconStatusAwaiting />
          </S.ButtonFooterCardRequested>
        </S.FooterCard>
      </S.Card>
    </>
  )
}
